var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-grow-warp"},[_c('span',{ref:"numberGrow",class:{ 'number-grow': _vm.isShowClass },style:({ 'font-size': _vm.fontSize, 'font-weight': _vm.fontWeight }),attrs:{"data-time":_vm.time}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }